var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { boxShadowMixinM } from '../../../../theme/mixins';
export var Menu = styled(AntMenu)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-menu-submenu-popup {\n    top: 65px !important;\n    .ant-menu-sub {\n      ", "\n      border-radius: 8px;\n    }\n  }\n"], ["\n  .ant-menu-submenu-popup {\n    top: 65px !important;\n    .ant-menu-sub {\n      ", "\n      border-radius: 8px;\n    }\n  }\n"])), boxShadowMixinM);
var templateObject_1;
//# sourceMappingURL=styled.js.map